import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class notificationService {
  audio: any;
  constructor(private http: HttpClient) {}

  packageNotification(data: any) {
    return this.http.post(
      environment.apiUrl + "packages/getByStatus/pagination",
      data,
    );
  }

  packerMoverNotification(data: any) {
    return this.http.post(
      environment.apiUrl + "packersMovers/get/pagination",
      data,
    );
  }
  // getNewDrivers(data:any){
  //   return this.http.post(environment.apiUrl+"drivers/get/pagination" , data);
  // }

  getDriverWithdrawalReq(data: any) {
    return this.http.post(
      environment.apiUrl + "driver/withdrawalrequest/get",
      data,
    );
  }

  getTrips(data: any) {
    return this.http.post(environment.apiUrl + "admin/enterprise/trips", data);
  }

  saveFcmToken(data: any) {
    return this.http.post(`${environment.apiUrl}admin/save-fcm-token`, data);
  }

  getNotifications() {
    return this.http.get(`${environment.apiUrl}admin/notifications`);
  }

  markNotificationRead(notificationId: string) {
    return this.http.put(
      `${environment.apiUrl}admin/notifications/${notificationId}/read`,
      {},
    );
  }
}
